var _polygon, _polygon2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonMakePaymentLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "191.45px",
    height: "41.888px",
    viewBox: "0 0 191.45 41.888",
    enableBackground: "new 0 0 191.45 41.888",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.7207,
    y1: 0,
    x2: 95.7207,
    y2: 41.8887
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88D3E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0675,
    style: {
      stopColor: "#7EC5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3338,
    style: {
      stopColor: "#5A9ECF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5345,
    style: {
      stopColor: "#4388C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#3A80C2"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "191.436,0 5.563,0 0.004,41.888 187.083,41.888 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.7539,
    y1: 1.7183,
    x2: 95.7539,
    y2: 39.8223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CB3E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#4EA1D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#2F7FBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    style: {
      stopColor: "#126DB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#0067AD"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_2_)",
    points: "189.195,1.718 7.419,1.718 2.311,39.822 185.112,39.822 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.307,12.111c3.092,0,4.152,0.474,4.919,1.219c1.106,1.083,1.467,2.73,1.151,4.423 c-0.316,1.692-1.354,3.476-2.573,4.378c-1.331,0.971-2.55,1.444-5.145,1.444h-1.67l-0.97,5.236h-4.265l3.092-16.7H58.307z  M55.689,19.83h1.557c0.406,0,1.083,0,1.693-0.248c0.609-0.249,1.151-0.768,1.332-1.761c0.18-0.993-0.203-1.467-0.745-1.715 c-0.542-0.249-1.241-0.249-1.715-0.249h-1.399L55.689,19.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M75.325,28.812h-3.747l0.249-1.354c-0.903,1.219-2.573,1.783-4.04,1.783c-3.972,0-5.71-3.114-5.033-6.703 c0.745-4.107,4.175-6.68,7.515-6.68c2.054,0,3.024,0.993,3.385,1.76l0.249-1.331h3.746L75.325,28.812z M66.478,22.605 c-0.203,1.151,0.271,3.137,2.527,3.137c1.332,0,2.257-0.632,2.889-1.399c0.406-0.497,0.655-1.038,0.813-1.603 c0.136-0.564,0.136-1.128-0.022-1.647c-0.248-0.857-0.925-1.738-2.505-1.738c-2.144,0-3.43,1.806-3.701,3.228V22.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.704,28.18l-2.437-11.893h3.994l1.196,7.267l3.746-7.267h3.972l-9.366,16.7h-3.972L79.704,28.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105.005,22.29l1.782-10.178h4.085l-3.092,16.7h-3.701l-4.514-10.065l-1.782,10.065h-4.085l3.092-16.7 h3.679L105.005,22.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.925,22.515c0.564-3.047,3.408-6.635,7.967-6.635s6.094,3.588,5.529,6.657 c-0.587,3.069-3.431,6.658-7.989,6.658s-6.093-3.588-5.507-6.658V22.515z M113.648,22.56c-0.315,1.806,0.813,3.137,2.438,3.137 s3.25-1.332,3.589-3.16c0.338-1.828-0.813-3.159-2.438-3.159s-3.228,1.331-3.565,3.159L113.648,22.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M123.49,16.287h3.882l0.474,7.786l3.498-7.786h3.159l0.678,7.786l3.317-7.786h3.858l-6.16,12.525h-3.476 l-0.632-8.102l-3.611,8.102h-3.476L123.49,16.287z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonMakePaymentLarge);
export default __webpack_public_path__ + "static/media/button_make-payment_large.305780f66818245410a74027cd617653.svg";
export { ForwardRef as ReactComponent };